import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=e85b1478&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=e85b1478&prod&lange=scsss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85b1478",
  null
  
)

export default component.exports